<template>
    <div class="sm:px-6 mb-8">
        <div
            class="bg-white shadow overflow-hidden rounded-lg border border-gray-200 divide-y divide-gray-200 w-full mx-auto max-w-xl md:max-w-none"
        >
            <div class="px-4 py-5 sm:p-6">
                <div class="flex justify-between items-center">
                    <div>
                        <h2 class="font-bold text-lg text-gray-800">
                            Sales Leaderboard
                        </h2>
                        <span class="text-sm text-gray-600">
                            {{ month }}
                        </span>
                    </div>

                    <Menu as="div" class="relative inline-block text-left z-10">
                        <div>
                            <MenuButton
                                class="-my-2 p-2 rounded-full bg-white flex items-center text-gray-400 hover:text-gray-600 focus:outline-none"
                            >
                                <span class="sr-only">Open options</span>
                                <DotsVerticalIcon
                                    class="h-5 w-5"
                                    aria-hidden="true"
                                />
                            </MenuButton>
                        </div>

                        <transition
                            enter-active-class="transition ease-out duration-100"
                            enter-from-class="transform opacity-0 scale-95"
                            enter-to-class="transform opacity-100 scale-100"
                            leave-active-class="transition ease-in duration-75"
                            leave-from-class="transform opacity-100 scale-100"
                            leave-to-class="transform opacity-0 scale-95"
                        >
                            <MenuItems
                                class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-md bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                            >
                                <div class="py-1">
                                    <MenuItem v-slot="{ active }">
                                        <button
                                            type="button"
                                            :class="[
                                                active
                                                    ? 'bg-gray-100 text-gray-900'
                                                    : 'text-gray-700',
                                                'w-full flex justify-between px-4 py-2 text-sm',
                                            ]"
                                            @click="timeFrame = 'current'"
                                        >
                                            <span>Current</span>
                                        </button>
                                    </MenuItem>
                                    <MenuItem v-slot="{ active }">
                                        <a
                                            href="#"
                                            :class="[
                                                active
                                                    ? 'bg-gray-100 text-gray-900'
                                                    : 'text-gray-700',
                                                'flex justify-between px-4 py-2 text-sm',
                                            ]"
                                            @click="timeFrame = 'last'"
                                        >
                                            <span>Last</span>
                                        </a>
                                    </MenuItem>
                                </div>
                            </MenuItems>
                        </transition>
                    </Menu>
                </div>

                <div class="flex justify-center py-16 px-6" v-if="loading">
                    <RefreshIcon
                        class="h-24 w-24 text-gray-400 animate-spin"
                        aria-hidden="true"
                    />
                </div>

                <units-sold
                    v-else
                    v-for="phoneRepresentative in phoneRepresentatives"
                    :canSeeAverageBottlesPerSale="canSeeAverageBottlesPerSale"
                    :key="phoneRepresentative.id"
                    :topSalesTier="topSalesTier"
                    :phoneRepresentative="phoneRepresentative"
                    :timeFrame="timeFrame"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { RefreshIcon } from "@heroicons/vue/outline";
import { DotsVerticalIcon } from "@heroicons/vue/solid";
import UnitsSold from "./UnitsSold.vue";
import { getPhoneRepresentatives } from "../../api/dashboard";

defineProps<{
    canSeeAverageBottlesPerSale?: string;
    topSalesTier: number;
}>();

const timeFrame = ref("current");
const phoneRepresentatives = ref<any>({});

const month = computed(() =>
    timeFrame.value === "current" ? "(This Month)" : "(Last Month)",
);
const loading = computed(() => _.isEmpty(phoneRepresentatives.value));

getPhoneRepresentatives().then((data) => {
    phoneRepresentatives.value = data.phoneRepresentatives;
});
</script>
